import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=370ca2e0"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('370ca2e0')) {
      api.createRecord('370ca2e0', component.options)
    } else {
      api.reload('370ca2e0', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=370ca2e0", function () {
      api.rerender('370ca2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/order/csg/edit.vue"
export default component.exports